/* Handles show/hide Privy top banner based off privyClosed session storage key */
function handlePrivyDismissContent(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.addedNodes) {
      for (const node of mutation.addedNodes) {    
        if (
          node &&
          node.nodeType === 1 &&
          (node.classList.contains('privy-bar') || node.classList.contains('privy-mobile-bar'))
        ) {
          // After detecting the privy banner injection in the document body we disconnect the observer
          observer.disconnect();
          
          const isPrivyBannerClosed = sessionStorage.getItem('privyBannerClosed');
          if (isPrivyBannerClosed) {
            hidePrivyContainer();
          } else {
            // Starts privy pusher observation for any style changes in the element
            privyPusherObserver();
          }
          
          break;
        }
      }
    }
  }
}

function hidePrivyContainer() {
  document.querySelector('.privy-bar-container').style.display = 'none';
  setHeaderTopOffset(0);
}

function setHeaderTopOffset(offset) {
  const fixedTop = document.querySelector('.fixed-top');
  fixedTop.style.setProperty('--privy-banner-push', offset + 'px');
}

function privyPusherObserver() {
  const privyBannerObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach(mutation => {
      const privyBar = document.querySelector('.privy-bar') || document.querySelector('.privy-mobile-bar');
      privyBar.style.display = 'block';
      privyBar.classList.remove('privy-slide-down');
      const privyBarHeight = privyBar?.clientHeight || 0;
      setHeaderTopOffset(privyBarHeight);
    })
  });

  const privyPusher = document.querySelector('.privy-pusher');
  // observes style changes in the privy pusher
  privyBannerObserver.observe(privyPusher, { attributes : true, attributeFilter : ['style'] });

  //adds event listener to the banner's dismiss button
  const privyDismissContent = document.querySelector('.privy-dismiss-content'); 
  if (privyDismissContent) {
    privyDismissContent.addEventListener('click', function handleDismissBanner() {
      sessionStorage?.setItem('privyBannerClosed', true);
      hidePrivyContainer();
      privyBannerObserver.disconnect();
      privyDismissContent.removeEventListener('click', handleDismissBanner);
    });
  }
}

const mutationObserver = new MutationObserver(handlePrivyDismissContent);

mutationObserver.observe(document.body, { childList: true, subtree: true });
